export default __webpack_public_path__ + "static/media/credits-icon.b078cf97.svg";